import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useCookieConsent } from './CookieConsentContext';
import '../../styles/components/cookies/CookieBanner.css';

const CookieBanner = () => {
  const { updateConsent } = useCookieConsent();

  const handleAccept = () => {
    updateConsent(true);
  };

  const handleDecline = () => {
    updateConsent(false);
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept all"
      declineButtonText="Reject non-essential"
      enableDeclineButton
      cookieName="cookieConsent"
      onAccept={handleAccept}
      onDecline={handleDecline}
      containerClasses="CookieConsent"
      buttonClasses="CookieConsent__button"
      declineButtonClasses="CookieConsent__declineButton"
      aria-label="Cookie consent banner"
    >
      We use cookies to provide you with a better experience. By accepting all cookies, you agree to our use of cookies to deliver and maintain our services and site, improve the quality of WeiFinders, personalise content and advertising, and measure the effectiveness of advertising. By rejecting non-essential cookies, we may still use certain cookies to ensure the proper functionality of our platform. Your preferences can be changed later. Read more on our{" "}
      <a href="/privacy-policy" className="CookieConsent__link">
        Privacy Policy
      </a>.
    </CookieConsent>
  );
};

export default CookieBanner;
